import React from "react";
import { Redirect } from "react-router-dom";

export default function linkTo(path) {
  return Component =>
    class extends React.Component {
      state = {
        clicked: false
      };

      click = () => this.setState({ clicked: true });

      render() {
        if (this.state.clicked) {
          return <Redirect to={path(this.props)} push />;
        }

        return <Component {...this.props} transition={this.click} />;
      }
    };
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/linkTo.jsx